import { Tooltip } from "@shopify/polaris";
import React from "react";
import Switch from "react-switch";

interface Props {
  value: "T" | "F" | undefined;
  onChange: (v: "T" | "F" | undefined) => void;
  name: string;
  helpText?: string;
}

export function ProductDraftToggle(props: Props) {
  return (
    <label
      style={{
        fontSize: ".92857143em",
        alignItems: "center",
        display: "flex",
        marginRight: 30,
        marginBottom: 0,
      }}
    >
      <Switch
        onChange={(checked) => props.onChange(checked ? "T" : "F")}
        checked={props.value === "T" ? true : false}
        height={20}
        width={50}
      />
      &nbsp;
      <Tooltip content={props.helpText}>
        <span>{props.name}</span>
      </Tooltip>
    </label>
  );
}
